(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quantity-action]');
    if (!trigger) return;
    const field = trigger.closest('[data-quantity]');
    const input = field?.querySelector('input[type="number"]');
    if (!input) return;
    const step = Number(input.step) || 1;
    const min = Number(input.min) || 0;
    const next = trigger.dataset.quantityAction === 'increase' ? Number(input.value) + step : Number(input.value) - step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
